import React, { useState } from 'react'

export default function InquiryForm(props) {
  const [radio, setRadio] = useState(null);
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form));
    const formData = new FormData(form);

    if (!formData.get('name') && !formData.get('return') && !formData.get('subject') && !formData.get('content') && !radio) {
      setStatus({ type: 'error', message: "Missing required fields" })
    } else {
      setSubmitting(true);
      setStatus(null);
      const additional_interests = props.serviceInterest;
      data.append('additional_interests', String(additional_interests).replace(",", ", "));

      try {
        let resp = await fetch('https://api.kylediggs.com/api/email/send', {
          method: 'POST',
          body: data,
        }).then(resp => resp.text());

        if (resp === "ok") {
          setStatus({ type: 'success', message: "Email sent successfully!" });
          form.reset();
          setRadio(null);
        } else {
          setStatus({ type: 'error', message: "Something went wrong. Please try again." });
        }
      } catch {
        setStatus({ type: 'error', message: "Network error. Please check your connection and try again." });
      } finally {
        setSubmitting(false);
      }
    }
  }

  return (
    <React.Fragment>
      <form className="inquiry form" onSubmit={(e) => onSubmit(e)}>
        {status?.type === 'error' ?
          <div className="status-container">
            <p className="status danger">
              <i className="fas fa-heart-broken"></i> {status.message}
            </p>
            <div className="close" onClick={() => setStatus(null)}>
              <i className="far fa-times"></i>
            </div>
          </div>
          : status?.type === 'success' ?
            <div className="status-container">
              <p className="status ok">
                <i className="fas fa-mailbox"></i> {status.message}
              </p>
              <div className="close" onClick={() => setStatus(null)}>
                <i className="far fa-times"></i>
              </div>
            </div>
            : ""}
        <input name="name" type="text" placeholder="Name*" required></input>
        <input name="return" type="email" placeholder="Email Address*" required></input>
        <input name="subject" type="text" placeholder="Subject*" required></input>
        <input name="website" type="text" placeholder="Website URL"></input>
        <textarea name="content" placeholder="Message*" required />
        <p><strong>Primary Interest*:</strong></p>
        <div className="radio-container">
          <label htmlFor="graphicdesign"><input type="radio" onClick={(e) => setRadio(e.value)} name="primary_interest" id="graphicdesign" value="graphicdesign" required />
            Graphic Design</label>
          <label htmlFor="website"><input type="radio" name="primary_interest" id="website" value="website" required />
            Web Development</label>
          <label htmlFor="logodesign"><input type="radio" name="primary_interest" id="logodesign" value="logodesign" required />
            Logo Design</label>
          <label htmlFor="other"><input type="radio" name="primary_interest" id="other" value="other" required />
            Other</label>
        </div>
        <button onClick={(e) => { props.onSelectedServices(e) }} className="button purple" type="button">Additional Service Interests ({props.serviceInterest?.length ? <strong>{props.serviceInterest.length}</strong> : "0"})</button>
        <button className="button purple" type="submit" value="Submit" disabled={submitting}>{submitting ? "Sending..." : "Submit"}</button>
      </form>
    </React.Fragment>
  )
}
